<template>
    <v-dialog v-model="dialog" width="700px">
        <v-card>
            <p class=".title ma-2">Add a photo to {{hsft.huis_code }} </p>
            <v-form ref="addHsft" v-model="addHsftValid">
                <v-row no-gutters>
                    <v-col class="ma-2">
                        <v-file-input v-model="hsft_foto" id="myFile" ref="myFile" show-size label="Choose a photo" filled accept=".jpg,.jpeg" prepend-icon="mdi-camera" @change="onFileChange" accep="image/jpg" :rules="hsft_fotoRules"></v-file-input>
                    </v-col>  
                </v-row>  
        
                <v-row v-if="url" no-gutters>
                    <v-col class="ma-2">
                        <img v-if="url" :src="url" height="200" />
                    </v-col>
                    <v-col>
                        Image width is {{image.width}} <br/>
                        <span v-if="image.width >= 2048" class="success">Width minimal 2048<br/> </span>
                        <span v-else class="error">Width minimal 2048<br/> </span>
                        Image height is {{image.height}} <br/>
                        <span v-if="image.height >= 1536" class="success">Height minimal 1536<br/> </span>
                        <span v-else class="error">Height minimal 1536<br/> </span>
                        <br>
                        <span v-if="Math.round((image.height / image.width) * 100) / 100 == 0.75" class="success">Width / Height ratio = 4:3<br/> </span>
                        <span v-else class="warning">Width / Height ratio is not 4:3.  Image will be cropped to 4:3<br/> </span>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col class="ma-2">
                        <v-select v-model="hsft.fttg_nr" required :items="fttg_nrKeuzes" item-value="fttg_nr" item-text="fttgtaal_oms" label="Photo tag" dense :rules="fttg_nrRules"></v-select>
                    </v-col>
                    
                </v-row>
                <v-row dense class="flex mx-2">
                    <v-select v-model="hsft.hsft_bewerkt" :items="hsft_bewerktKeuzes" item-value="value" item-text="oms" label="Image Adjustment" dense></v-select>
                </v-row>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="addHsft" :disabled="!addHsftValid || this.image.width < 2048 || this.image.height < 1536" :loading="uploading">Save</v-btn>
                <v-btn color="primary"  small @click="dialog = false" :disabled="uploading">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() { 
            return {
                dialog: false,
                addHsftValid: false,
                uploading: false,
                huis_encrid: null,
                fttg_nrKeuzes: [],
                hsft_bewerktKeuzes: [],
                hsft_foto: null,
                hsft: {},
                url: null,
                image:{
                    size:'',
                    height:'',
                    width:'',
                    src: null
                },
                fttg_nrRules: [
                    v => !!v || "A Tag is required"
                ],
                hsft_fotoRules: [
                    v => !!v || "A photo is required"
                ]
            }
        },
        mounted() {   /* Work around voor Safari */
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            })
        },
        methods: {
            open(huis_encrid) {
                var deze = this;
                this.dialog = true;
                this.url = null;
                this.hsft_foto = null;
                this.$axios.post("ares/json/ares/huis/hsft/getHuisToAddHsft.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToAddHsft"
                    },
                    getHuisToAddHsft: {
                        huis_encrid: huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsft = res.data.getHuisToAddHsft;
                        res.data.getHuisToAddHsft.fttg_nrKeuzes.forEach(function(fttg) {
                            deze.fttg_nrKeuzes.push(fttg); 
                        });
                        this.hsft_bewerktKeuzes = res.data.getHuisToAddHsft.hsft_bewerktKeuzes;
                    }
                });
            },
            onFileChange() {
                const file = this.hsft_foto;
                if (this.hsft_foto != null) {
                    this.url = URL.createObjectURL(file);
      
                    /* let file = this.$refs.myFile.files[0]; */
                    if(!file || file.type.indexOf('image/') !== 0) return;
      
                    this.image.size = file.size;
      
                    let reader = new FileReader();
      
                    reader.readAsDataURL(file);
                    reader.onload = evt => {
                        let img = new Image();
                        img.onload = () => {
                            this.image.width = img.width;
                            this.image.height = img.height;
                        }
                        img.src = evt.target.result;
                        this.image.src = img.src;
                    };
                    reader.onerror = evt => {
                        console.error(evt);
                    } 
                } else  {
                    this.url = null;
                    this.hsft.fttg_nr = null;
                }   
            },
            addHsft() {
                this.addHsftValid = false;
                this.uploading = true;
                this.$axios.post("ares/json/ares/huis/hsft/addHsft2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHsft"
                    },
                    addHsft: {
                        huis_encrid: this.hsft.huis_encrid,
                        fttg_nr: this.hsft.fttg_nr,
                        hsft_bewerkt: this.hsft.hsft_bewerkt,
                        hsft_foto: this.image.src
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.uploading = false;
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHsft.text,
                            color: res.data.addHsft.color
                        }); 
                        this.$emit('updateData');
                        this.uploading = false;
                        this.dialog = false;
                    }
                })
            }
        }
    }
</script>

